"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromImmerPatch = void 0;
const path_1 = require("./path");
function fromImmerPatch(immerPatch) {
    const path = (0, path_1.joinPathParts)(immerPatch.path);
    switch (immerPatch.op) {
        case 'add':
        case 'replace':
            return { op: 'set', path, value: immerPatch.value };
        case 'remove':
            return { op: 'delete', path };
        case 'resortArray':
            return { op: 'resortArray', path, indexMap: immerPatch.indexes };
    }
}
exports.fromImmerPatch = fromImmerPatch;
